export const MUNI_TAXABILITIES = [
    {display:'Federally Taxable', value:'holdTaxable=Y'},
    {display:'Build America Bonds', value:'holdTaxable=BAB', oneOf:'holdTaxable=Y'},
    {display:'Federally Tax-Exempt', value:'holdTaxable=N'},
    {display:'State Taxable', value:'holdStateTaxExempt=N'},
    {display:'State Tax-Exempt', value:'holdStateTaxExempt=Y'},
    {display:'Subject to AMT', value:'holdAltMinTax=Y'},
    {display:'Exempt from AMT', value:'holdAltMinTax=N'}
].map(a => {
    a.label = a.display
    return a
})